{
  "language": {
    "select": "Cambiar idioma",
    "saveError": "No se pudo guardar tu idioma en el perfil."
  },
  "dateRangePicker": {
    "placeholder": "Selecciona el periodo",
    "dateFormat": "dd 'de' LLL"
  },
  "toast": {
    "error": "Error",
    "success": "Éxito"
  },
  "whatsApp": {
    "ariaLabel": "Escríbenos por WhatsApp",
    "tooltip": "Escríbenos"
  },
  "loader": {
    "loading": "Cargando...",
    "preparing": "Preparando una experiencia increíble...",
    "loadingVideo": "Cargando reproductor de video...",
    "calculatingStats": "Calculando estadísticas",
    "analyzingProgress": "Analizando tu progreso...",
    "pleaseWait": "Espera un momento...",
    "navigating": "Navegando..."
  },
  "notifications": {
    "reasons": {
      "lessonCompleted": "Completaste una clase",
      "moduleCompleted": "Completaste un módulo",
      "courseCompleted": "Terminaste un curso",
      "commentPosted": "Publicaste un comentario",
      "dailyLogin": "Inicio de sesión diario",
      "streakBonus": "Bonus de racha",
      "quizCompleted": "Completaste un quiz",
      "certificateEarned": "Conseguiste un certificado",
      "exerciseCompleted": "Completaste un ejercicio",
      "projectSubmitted": "Enviaste un proyecto",
      "helpColleague": "Ayudaste a un compañero",
      "firstLesson": "Primera clase completada",
      "communityPostCreated": "Creaste una publicación en la comunidad",
      "communityCommentCreated": "Comentaste en la comunidad",
      "communityPostLiked": "Te gustó una publicación de la comunidad",
      "communityCommentLiked": "Te gustó un comentario",
      "communityMentioned": "Te mencionaron en la comunidad",
      "courseStarted": "Empezaste un curso",
      "courseProgress": "Avanzaste en el curso",
      "lessonFavorited": "Guardaste una clase en favoritos",
      "postLiked": "Diste me gusta a un post",
      "postReplied": "Respondiste a un post",
      "postShared": "Compartiste un post",
      "dailyChecklistBonus": "Bono de la Trifecta diaria"
    },
    "timeAgo": {
      "now": "ahora"
    },
    "grouped": {
      "title": "+{{points}} XP hoy",
      "message": "{{count}} acciones sumaron puntos hoy"
    },
    "clickToView": "Haz clic para ver",
    "title": "Notificaciones",
    "newCount_one": "{{count}} nueva",
    "newCount_zero": "{{count}} nuevas",
    "newCount_other": "{{count}} nuevas",
    "markAllRead": "Marcar como leídas",
    "filters": {
      "all": "Todas",
      "unread": "No leídas"
    },
    "loading": "Cargando...",
    "empty": {
      "unreadTitle": "¡Todo al día!",
      "allTitle": "Ninguna notificación",
      "unreadDescription": "No tienes notificaciones pendientes",
      "allDescription": "Tus notificaciones aparecerán aquí"
    }
  },
  "videoField": {
    "variants": {
      "mirroredRoot": {
        "name": "Raíz reflejada",
        "description": "Copa y raíz encontrándose en la línea del horizonte"
      },
      "particleCanopy": {
        "name": "Copa de partículas",
        "description": "Columna de luz que florece en partículas"
      },
      "waterMonolith": {
        "name": "Monolito en el agua",
        "description": "Escultura del símbolo reflejada en agua quieta"
      }
    }
  },
  "gamifiedAvatar": {
    "title": "{{level}} - {{points}} XP"
  },
  "imageUpload": {
    "invalidType": "Por favor, selecciona una imagen",
    "tooLarge": "La imagen debe pesar como máximo 5MB",
    "uploadError": "Error al subir la imagen",
    "previewAlt": "Vista previa",
    "replace": "Cambiar",
    "remove": "Eliminar",
    "uploading": "Subiendo...",
    "dropzone": "Haz clic o arrastra una imagen aquí",
    "hint": "JPG, PNG, GIF o WebP de hasta 5MB"
  },
  "colorPicker": {
    "color": "Color",
    "hue": "Tono",
    "hex": "Hex",
    "preview": "Vista previa",
    "currentColor": "Color actual",
    "newColor": "Nuevo color",
    "presets": "Colores predefinidos",
    "cancel": "Cancelar",
    "apply": "Aplicar"
  },
  "pwaDashboard": {
    "initializing": "Inicializando PWA...",
    "title": "Progressive Web App",
    "subtitle": "Configura y supervisa las funciones PWA de la plataforma",
    "online": "En línea",
    "offline": "Sin conexión",
    "installed": "Instalada",
    "dismiss": "Descartar",
    "install": {
      "title": "Instalación",
      "description": "Instala la aplicación para tener acceso rápido y funciones sin conexión",
      "success": "¡Aplicación instalada correctamente!",
      "available": "Puedes instalar la aplicación en tu dispositivo.",
      "button": "Instalar aplicación",
      "notNow": "Ahora no",
      "unavailable": "La instalación no está disponible en este momento.",
      "unavailableHint": "Esto puede ocurrir si la aplicación ya está instalada o si el navegador no admite la instalación de PWA.",
      "stats": {
        "promptsShown": "Avisos mostrados",
        "installs": "Instalaciones",
        "dismissed": "Descartados"
      }
    },
    "updates": {
      "title": "Actualizaciones",
      "description": "Mantén la aplicación siempre actualizada",
      "newVersion": "¡Nueva versión disponible!",
      "upToDate": "Aplicación actualizada",
      "lastCheck": "Última comprobación: {{date}}",
      "neverChecked": "Nunca comprobado",
      "updateNow": "Actualizar ahora",
      "checkForUpdates": "Buscar actualizaciones",
      "info": "Información de la actualización:",
      "status": "Estado: {{status}}",
      "waiting": "En espera",
      "available": "Disponible",
      "size": "Tamaño: {{size}}",
      "changes": "Cambios:"
    },
    "features": {
      "title": "Funciones PWA",
      "description": "Funciones avanzadas de la aplicación web progresiva",
      "active": "Activo",
      "inactive": "Inactivo",
      "offline": {
        "name": "Modo sin conexión",
        "description": "Accede al contenido incluso sin internet"
      },
      "push": {
        "name": "Notificaciones push",
        "description": "Recibe notificaciones importantes"
      },
      "backgroundSync": {
        "name": "Sincronización en segundo plano",
        "description": "Sincroniza datos automáticamente"
      }
    },
    "metrics": {
      "title": "Métricas de uso",
      "totalInstalls": "Total de instalaciones",
      "dailyActiveUsers": "Usuarios activos (hoy)",
      "retentionRate": "Tasa de retención",
      "offlineUsage": "Uso sin conexión",
      "updateSuccessRate": "Tasa de éxito de actualizaciones"
    },
    "storage": {
      "title": "Almacenamiento",
      "appCache": "Caché de la aplicación",
      "platforms": "Plataformas",
      "installs_one": "{{count}} instalación",
      "installs_zero": "{{count}} instalaciones",
      "installs_other": "{{count}} instalaciones",
      "refresh": "Actualizar información"
    },
    "security": {
      "title": "Seguridad y privacidad",
      "https": "Aplicación servida por HTTPS",
      "secure": "Seguro",
      "serviceWorker": "Service Worker activo",
      "notice": "Todos los datos se almacenan localmente y cifrados. La aplicación funciona sin conexión respetando tu privacidad."
    }
  },
  "pwa": {
    "manifest": {
      "name": "Xtreed - Plataforma de aprendizaje",
      "description": "Plataforma completa de aprendizaje en desarrollo",
      "shortcuts": {
        "courses": {
          "name": "Mis cursos",
          "shortName": "Cursos",
          "description": "Acceder a mis cursos"
        },
        "achievements": {
          "name": "Logros",
          "shortName": "Logros",
          "description": "Ver mis logros"
        }
      }
    },
    "errors": {
      "initializationFailed": "No se pudo inicializar la PWA",
      "unknown": "Error desconocido",
      "installPromptUnavailable": "El aviso de instalación no está disponible",
      "installFailed": "Error en la instalación",
      "updateCheckFailed": "No se pudieron buscar actualizaciones",
      "skipWaitingFailed": "No se pudo aplicar la actualización",
      "serviceWorkerNotRegistered": "Service Worker no registrado",
      "workboxNotInitialized": "Workbox no inicializado",
      "notificationsNotSupported": "Notificaciones no compatibles",
      "notificationPermissionDenied": "Permiso de notificaciones denegado"
    }
  },
  "coursePlaceholder": "Curso",
  "tenant": {
    "defaultName": "Área de miembros"
  },
  "gamificationWidget": {
    "nextLevel": "Siguiente nivel:",
    "xpToNext": "Te faltan <strong>{{xp}} XP</strong>",
    "maxLevel": "Llegaste al nivel máximo. Sigue sumando XP para subir en el ranking.",
    "earnXpHint": "Gana XP completando clases, comentando y manteniendo tu racha de estudio.",
    "position": "Posición",
    "streak": "Racha",
    "streakDays_one": "{{count}} día",
    "streakDays_zero": "{{count}} días",
    "streakDays_other": "{{count}} días",
    "viewRanking": "Ver ranking"
  }
}
